import workshop_rails from '../images/saas-giojuliao.png';
import railsMarketplace from '../images/marketplace-giojuliao.png';
import crossfitwod from '../images/fitness-app-giojuliao.png';
import englishAgent from '../images/personal-branding-giojuliao.png';
import emailMapScraper from '../images/map-scraper-giojuliao.png';
import legalAgent from '../images/legal_agent-giojuliao.png';
import investorAgent from '../images/investment-agent-giojuliao.png';
import hrAgent from '../images/human-resources-agent-giojuliao.png';
import realestate from '../images/realestate-agent-giojuliao.png';
import salesAgent from '../images/sales_agent.png';
import shoppingAgent from '../images/shopping-agent-giojuliao.png';
import shopifyAgent from '../images/shopify-agent-giojuliao.png';

export const ProjectsContent = [
  {
    link: 'https://www.giojuliao.com/shopify_agent',
    img: shopifyAgent,
    name: 'AI Shopify Agent',
    excerpt: `Agent hosted in e-commerce domain that act as sales rep to guide buyers on product information.
             Answering questions such as which product is best for dry skin?`,
    tools: 'React, openAI, Perplexity, Google',
  },
  {
    link: 'https://www.giojuliao.com/investor_agent',
    img: investorAgent,
    name: 'AI Investor Agent',
    excerpt: `This agent provides expert financial advise to visitors request,
    for exclusive use of Financial advisors.`,
    tools: 'React, openAI, Perplexity, Google',
  },
  {
    link: 'https://www.giojuliao.com/hr_agent',
    img: hrAgent,
    name: 'Human Resources AI Agent',
    excerpt: `This agent provides expert Resume building advise to visitors request,
    for exclusive use of HR advisors.`,
    tools: 'React, openAI, Perplexity, Google',
  },
  {
    link: 'https://www.giojuliao.com/sales_agent',
    img: salesAgent,
    name: 'AI Sales Agent',
    excerpt: `This agent provides expert recommendations for closing sales,
    uses Jordan Belfort methodology.`,
    tools: 'React, openAI, Perplexity, Google',
  },
  {
    link: 'https://www.giojuliao.com/realestate_agent',
    img: realestate,
    name: 'Real Estate AI Agent',
    excerpt: `This agent provides realtors with immediate response to customers property finding interest,
    contact me to know more.`,
    tools: 'React, openAI, Perplexity, Google',
  },
  {
    link: 'https://www.giojuliao.com/shopping_agent',
    img: shoppingAgent,
    name: 'AI Shopping Agent',
    excerpt: `This agent provides shopping guidance of products uploaded by sellers in the Google merchant center.
    It can guide you through best prices and quality selection. Contact me to know more.`,
    tools: 'React, openAI, Perplexity, Google',
  },
  {
    link: 'https://www.giojuliao.com/google_maps_email_scraper',
    img: emailMapScraper,
    name: 'Google Maps Email Scraper AI Agent',
    excerpt: `This agent provides a solution to scrape data from google maps website 
    plus it helps professionals to add AI to their website.`,
    tools: 'React, openAI, Perplexity, Google',
  },
  {
    link: 'https://www.giojuliao.com/personal_branding_agent',
    img: englishAgent,
    name: 'AI Personal Branding Agent',
    excerpt: `This agent provides a social media post for users to add to their social networks 
    plus it helps Personal Branding Experts to add AI to their website.`,
    tools: 'React, openAI, Perplexity, Google',
  },
  {
    link: 'https://www.giojuliao.com/legal_agent',
    img: legalAgent,
    name: 'AI Legal Advisor Agent',
    excerpt: `This agent provides expert legal advise to visitors request,
             for exclusive use of USA attorneys.`,
    tools: 'React, openAI, Perplexity, Google',
  },
  {
    link: 'https://gjuliao.github.io/crossfitwod/',
    img: crossfitwod,
    name: 'Crossfit WOD Generator',
    excerpt: `The Crossfit Wod generator allows users to filter what type of workout they want to do
    and you can generate as much workouts the user desires`,
    tools: 'React',
  },
  {
    link: 'https://github.com/gjuliao/workshop',
    img: workshop_rails,
    name: 'Workshop - SaaS with Stripe and admin dashboard',
    excerpt: `Rails workshop app with admin dashboard and integration with Stripe
    to charge and refund complete or partial amounts.`,
    tools: 'Ruby on Rails',
  },
  {
    link: 'https://github.com/gjuliao/Rails_Marketplace',
    img: railsMarketplace,
    name: 'Rails Marketplace',
    excerpt: `This is a RoR marketplace where users can create products, 
    and can also become customer of other people products. 
    Great for a starter for any marketplace project.`,
    tools: 'Ruby on Rails · CSS',
  },

];
